import React, { useEffect, useState } from "react"; 
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import BasePopup from "../../../Components/Base/BasePopup";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";

const EnvioRotogramaViagemPopup = (props: any) => {
    const [relatorio, setRelatorio] = useState<any>({});
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [usuariosEnvio, setUsuariosEnvio] = useState([]);
    
            
    const [usuario, setUsuario] = useState<any | null>(() => {
        const usuario = localStorage.getItem("user");
        return usuario ? JSON.parse(usuario) : [];
    });

    useEffect(() => {
        relatorio.viagem_id = props.viagemId; 
        const fetchData = async () => {
            await carregarUsuariosAsync();
        };

        fetchData();
    }, [props.viagemId]);

    async function carregarUsuariosAsync() {
        setLoading(true);
        let viagemId = relatorio.viagem_id ?? 0;
        if (viagemId == 0) {
            setLoading(false);
            enqueueSnackbar('Preencha o campo viagem!', {variant: 'error'});
            return;
        }

        let response: any = await axios.get(`rotograma/buscaUsuariosPorViagem?viagemId=${viagemId}`);
        if (response.data.length == 0) {
            enqueueSnackbar('Nenhum usuário encontrado para esta viagem!', {variant: 'warning'});
        }

        setUsuariosEnvio(response.data);
        setLoading(false);
    }

    async function enviaEmail() {
        if (relatorio.viagem_id == null || relatorio.viagem_id <= 0) {
            enqueueSnackbar('Preencha o campo viagem!', {variant: 'error'});
            return;
        }

        setLoading(true);
        const response = await axios.get(`/rotograma/buscaDados?viagemId=${relatorio.viagem_id}`);
        const dadosViagem = response.data;
        if ((dadosViagem?.id??0) == 0) {
            setLoading(false);
            enqueueSnackbar('Viagem não encontrada!', {variant: 'error'});
            return;
        }

        if ((dadosViagem?.enviar_rotograma??0) == 0) {
            setLoading(false);
            enqueueSnackbar('Operação não configurada para envio!', {variant: 'error'});
            return;
        }

        try {
            await confirm({ title: "Deseja realmente reenviar o e-mail para os usuários relacionados?" });
            await fetch(`https://k1.grupokrona.com.br/jobs/email/emailMensagemRotogramaViagemJob.php?viagem_id=${relatorio.viagem_id}&id=${relatorio.contato_id}`);
            //enqueueSnackbar('Enviado com sucesso!');
        }
        catch (err:any) {
            console.error(err);
            enqueueSnackbar('Não enviado!', {variant: 'error'});
            if (err?.message!=undefined) {
                enqueueSnackbar(err.message, {variant: 'error'});
            }
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <BasePopup
            height="470px"
            size={'md'}
            buttonTitle="Enviar"
            title="Enviar   Rotograma"
            isOpen={props.isOpen}
            onClose={props.onClose}
            onClickFirstButtonPopupCallback={enviaEmail}
            isPesquisa='false'
            confirmClose={false}>
            <div className="row">
                <TextFieldComponent 
                    label="Número Viagem"
                    divClassName="col-lg-6 col-md-6 col-sm-6 col-6"
                    model={relatorio}
                    field="viagem_id" />
                    
                <Button variant="contained" color="info" 
                    className="btn col-lg-6 col-md-6 col-sm-6 col-6"
                    style={{ float: 'left' }}
                    onClick={() => carregarUsuariosAsync()}>
                    Carregar Usuários
                </Button>
                    
                <DropDownListComponent
                    label='Usuarios'
                    required
                    className="col-lg-6 col-md-6 col-sm-6 col-6"
                    options={usuariosEnvio}
                    valueField='id'
                    textField='nome'
                    model={relatorio}
                    modelField='contato_id' />
            </div>
        </BasePopup>
    );
}

export default EnvioRotogramaViagemPopup;

